<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs6 sm6>
                    <cal-picker
                      v-model="form.tranDateFrom"
                      :label="labels.tranDateFrom"
                      :data-vv-as="labels.tranDateFrom"
                      data-vv-name="form.tranDateFrom"
                      :error-messages="errors.collect('form.tranDateFrom')"
                      v-validate="'required'"
                      :max="this.today"
                    />
                  </v-flex>
                  <v-flex xs6 sm6>
                    <cal-picker
                      v-model="form.tranDateTo"
                      :label="labels.tranDateTo"
                      :data-vv-as="labels.tranDateTo"
                      data-vv-name="form.tranDateTo"
                      :error-messages="errors.collect('form.tranDateTo')"
                      v-validate="'required'"
                      :max="this.today"
                      :min="this.form.tranDateFrom"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.branch"
                      :label="labels.branch"
                      :error-messages="errors.collect('form.branch')"
                      :data-vv-as="labels.branch"
                      v-validate="'required'"
                      data-vv-name="form.branch"
                      append-icon="mdi-magnify"
                      @click:append="showBranchHelpList = true"
                      @click="showBranchHelpList = true"
                      readonly
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Sort Order</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <sort-order-table :columns="columns" :headers="headers" :sortedListContainer="sortedListContainer" ref="sortOrderTable" />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel4" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Report Setting</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-autocomplete
                      :label="labels.rptType"
                      :items="rptTypeList"
                      v-model="form.rptType"
                      item-text="value"
                      item-value="code"
                      data-vv-name="rptType"
                      :data-vv-as="labels.rptType"
                      v-validate="'required'"
                      :error-messages="errors.collect('rptType')"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="form.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import SortOrderTable from '@/components/reusable/SortOrderTable'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [MessageMixin],
  components: {
    MultiBranchHelpList,
    SortOrderTable
  },
  data() {
    return {
      menu: {},
      showBranchHelpList: false,
      submitting: false,
      form: {
        rptType: 'D',
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        branch: 'All',
        pbPrtParam: true,
        format: 'PDF'
      },
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        branch: 'Branch',
        sortOrder: 'Sort Order',
        rptType: 'Report Type',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO'
      },
      rptTypeList: [
        { code: 'D', value: 'Detail' },
        { code: 'S', value: 'Summary' },
        { code: 'B', value: 'Both' }
      ],
      columns: [
        { label: 'Branch', value: 'branch' },
        { label: 'Business Source', value: 'busSrc' },
        { label: 'Class', value: 'busCls' },
        { label: 'Class Group', value: 'busClsGrp' },
        { label: 'Direct/RI', value: 'dri' },
        { label: 'Executive', value: 'exec' },
        { label: 'Fund', value: 'fund' },
        { label: 'Policy Type', value: 'polType' }
      ],
      headers: [
        { label: 'Sub Total', value: 'subTotal' },
        { label: 'Page Break', value: 'pageBreak' }
      ],
      sortedListContainer: {
        sortedList: [],
        cDescList: []
      },
      supportedFormat: [],
      panel1: [0],
      panel2: [],
      panel3: [],
      panel4: [0],
      yearsList: [],
      today: new Date()
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    years() {
      const tempYearList = []
      const year = new Date().getFullYear()
      tempYearList.push(0)
      for (var i = 1999; i <= year; i++) {
        tempYearList.push(i)
      }
      return tempYearList
    },
    doValidateToLossYear() {
      if (this.form.lossYearFrom !== 0) {
        return '|valMaxLossYear:' + this.form.lossYearFrom
      } else {
        return ''
      }
    },
    doValidateToUWYear() {
      if (this.form.uwYearFrm !== 0) {
        return '|valMaxUWYear:' + this.form.uwYearFrm
      } else {
        return ''
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.clmMovement
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      if (this.sortedListContainer.sortedList.length === 0) {
        this.$toast.error('Please select sort columns.')
        return
      }
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const sortedList = [...this.$refs.sortOrderTable.getLabels()]
        .sort((a, b) => (a.index || 0) - (b.index || 0))
      const apiURI = this.menu.export
      if (apiURI) {
        this.form.sort = sortedList
        this.form.cDesc = this.sortedListContainer.cDescList
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    }
  },
  created() {
    this.$validator.extend('valMaxLossYear', {
      getMessage(field, args) {
        return 'Loss Year To cannot be earlier than Loss Year From'
      },
      validate(value, args) {
        let dateSelected = args[0]
        if (value < dateSelected) {
          return false
        } else return true
      }
    })
    this.$validator.extend('valMaxUWYear', {
      getMessage(field, args) {
        return 'Underwriting Year To cannot be earlier than Underwriting Year From'
      },
      validate(value, args) {
        let dateSelected = args[0]
        if (value < dateSelected) {
          return false
        } else return true
      }
    })
  }
}
</script>
